export default {

    /** 郵便番号CSVインポート **/
    getImportPostalCsvStatus (state) {
        return state.importPostalCsvStatus
    },
    /** システムメール送信情報取得**/
    getSysMailInfo (state) {
        return state.sysMailInfo
    },
    getSysMailInfoLoadStatus (state) {
        return state.sysMailInfoLoadStatus
    },

    /** システムメールグループ名・ステータス修正　**/
    getMailGroupEditSaveStatus (state) {
        return state.mailGroupEditSaveStatus
    },

    /** システムメールグループ名・ステータス修正　**/
    getMailGroupEditDelStatus (state) {
        return state.mailGroupEditDelStatus
    },

    /** システムメール送信グループ **/
    getMailGroupMember (state) {
        return state.mailGroupMember
    },
    getMailGroupMemberLoadStatus (state) {
        return state.mailGroupMemberLoadStatus
    },
    getMailGroupMemberSelected (state) {
        return state.mailGroupMemberSelected
    },
    getChangeMailGroupStatus (state) {
        return state.changeMailGroupStatus
    },

    /** システムメールテンプレート保存　**/
    getMailTempSave (state) {
        return state.mailTempSave
    },
    getMailTempSaveStatus (state) {
        return state.mailTempSaveStatus
    },
    getMailTempDelStatus (state) {
        return state.mailTempDelStatus
    },
    getSysMailSendStatus (state) {
        return state.sysMailSendStatus
    },
    getSysMailSendCnt (state) {
        return state.sysMailSendCnt
    }



}

